module.exports = __webpack_public_path__ + "img/step2.963350c6.png";